import { Component, OnInit, ViewEncapsulation, OnChanges, Input, SimpleChanges } from '@angular/core';
import { I18nService } from 'app/services/i18n/i18n.service';
import { Rest } from '../../../../rest/rest_client';
import { ServerValidatedFormComponent } from '../../../server-validated-form/server-validated-form.component';

@Component({
  selector: 'app-default-assist-level-sc350m',
  templateUrl: './default-assist-level-sc350m.component.html',
  styleUrls: ['./default-assist-level-sc350m.component.css'],
})
export class DefaultAssistLevelSc350mComponent extends ServerValidatedFormComponent implements OnInit {
  
  @Input() aslParameters: Rest.DefaultAssistLevelSC350M;
  
  modeOptions: any = [
    { label: "Enable. SC350M will set the default assist level to bike", value: "ENABLE" },
    { label: "Disable. SC350M will not set an assist level", value: "DISABLE" },
  ];

  enforceOptions: any = [
    { label: "Do not enforce, allow it to be changed by the user", value: "NOT_ENFORCE" },
    { label: "Enforce assist level and change it back to <Default Assist Level>", value: "ENFORCE" },
  ];

  constructor(protected i18n: I18nService) { super(i18n); }
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges){
    if (changes["deviceParams"]) {
      console.log("arrive deviceParams", this.aslParameters);
    }
  }

}
